// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../../BaseIcon";
import type { BaseIconProps } from "../../types";

const solidContent = `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_less--line"><path id="Union" d="M36 14L16.3633 23L36 32V36L12.5833 25.2674C12.2279 25.1045 12 24.7493 12 24.3583V21.6417C12 21.2507 12.2279 20.8955 12.5833 20.7326L36 10V14Z" style="fill: currentColor"/></g></svg>`;
const lineContent = `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_less--line"><path id="Union" d="M36 14L16.3633 23L36 32V36L12.5833 25.2674C12.2279 25.1045 12 24.7493 12 24.3583V21.6417C12 21.2507 12.2279 20.8955 12.5833 20.7326L36 10V14Z" style="fill: currentColor"/></g></svg>`;

export const Less: React.FC<BaseIconProps> = (props) => (
  <BaseIcon {...props} solidContent={solidContent} lineContent={lineContent} />
);
